import './EquipmentDataUsage.scss';
import template from './EquipmentDataUsage.html';

/* @ngInject */
function EquipmentDataUsageModalController(
  $filter,
  $uibModalInstance,
  NgTableParams,
  EquipmentInfoService,
  DataUsageService,
  equipment
) {
  const vm = this;
  const equipmentUsageInArray = [];

  vm.equipmentUsage = {};
  vm.tableParams = null;
  vm.close = close;

  EquipmentInfoService
    .getEquipmentById(equipment)
    .then((equipmentObjects) => {
      _.forEach(equipmentObjects, (eq) => {
        vm.equipmentUsage[eq.id] = {
          equipment: eq,
          usage: {}
        };
      });
      return getRecentUsage(equipment);
    });

  function getRecentUsage(equipmentIds) {

    const updateUsage = (usages = {}) => {
      _.forEach(vm.equipmentUsage, (__, eqId) => {
        const vmUsage = vm.equipmentUsage[eqId].usage;
        const newUsage = usages[eqId] || {};
        vmUsage.current = newUsage.current || 0;
        vmUsage.previous = newUsage.previous || 0;
        const convertToGB = valueInBytes => (valueInBytes ? valueInBytes / (1024 ** 3) : 0).toFixed(2);
        // TODO: These should be methods rather than constants
        vmUsage.currentPretty = convertToGB(vmUsage.current);
        vmUsage.previousPretty = convertToGB(vmUsage.previous);
      });
    };

    return DataUsageService
      .getRecentUsage(equipmentIds)
      .then(updateUsage)
      .then(initiateNgTable)
      .catch(console.error);
  }

  function initiateNgTable() {
    _.forEach(vm.equipmentUsage, (eqModel) => {
      equipmentUsageInArray.push(eqModel);
    });
    if (vm.tableParams) {
      vm.tableParams.page(1);
      vm.tableParams.reload();
    } else {
      // perform check to update existing params if they exists, rather than creating a new one
      vm.tableParams = new NgTableParams({
        page: 1,
        count: 10,
        sorting: {
          'usage.current': 'desc',
          'equipment.name': 'asc'
        }
      }, {
        total: _.size(equipmentUsageInArray),
        getData($table) {
          const params = $table._params;
          let orderedData = $table.sorting() ?
            $filter('orderBy')(equipmentUsageInArray, $table.orderBy()) : equipmentUsageInArray;
          orderedData = $table.hasFilter() ?
            $filter('filter')(orderedData, $table.filter()) : orderedData;
          $table.total(orderedData.length);
          return orderedData.slice((params.page - 1) * params.count, params.page * params.count);
        }
      });
    }
  }

  function close() {
    $uibModalInstance.dismiss('cancelled');
  }
}

export default {
  template,
  controller: EquipmentDataUsageModalController,
  controllerAs: 'EquipmentDataUsageCtrl'
};
